import React, { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import API_URL from './api/config';
import LoginGuard from "./components/LoginGuard";


//Global declaration at top of the file
window.setValueFromAndroid = function(value) {
    localStorage.setItem("oneSignalId", value); // persist
  };

  const isValidEmail = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  
  const isValidPhone = (value) =>
    /^(\+?[1-9]\d{7,14}|0\d{9,14})$/.test(value);

function Login() {
    
  const queryClient = useQueryClient();
    const [values, setValues] = useState({ email_phone: '', password: '' });
    const navigate = useNavigate();
    axios.defaults.withCredentials = true;
 const [showPw, setShowPw] = useState(false);
    const [oneSignalId, setOneSignalId] = useState('');

    useEffect(() => {
      //Now it will work even if Android calls before React is ready
      const savedId = localStorage.getItem("oneSignalId");
      if (savedId) {
        setOneSignalId(savedId);
      }
    }, []);

  
    
    

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = (e) => {

      e.preventDefault();

      const loginValue = values.email_phone.trim();

        // Validate email / phone
        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loginValue);
        const isPhone = /^(\+?[1-9]\d{7,14}|0\d{9,14})$/.test(loginValue);

        
        if (!isEmail && !isPhone) {
          toast.info("Enter valid email or phone number", {
            position: "top-right",
            autoClose: 3000
          });
          return;
        }


      setIsSubmitting(true); // disable button
    
      axios.post(`${API_URL}/login-api`, {
        login: loginValue,
        password: values.password,
        oneSignalId
      })
        .then(res => {

           // Handle deactivated account
            if (res.data.Status === "Deactivated") {
              navigate("/deactivated-account", {
                state: {
                  
                  userid: res.data.userid,
                  email: res.data.email,
                  period: res.data.period,
                  date_period: res.data.date_period
                }
              });
              return;
            }

         if (res.data.Status === "Success") {

            queryClient.clear();
            localStorage.setItem('user_id', res.data.user_id);
            localStorage.setItem('family_code', res.data.family_code);
            localStorage.setItem('family_admin', res.data.family_admin);
    
            toast.success("Login successful!", { position: "top-right", autoClose: 3000 });
            navigate(res.data.redirect);
          } else {
            toast.info(res.data.Message, { position: "top-right", autoClose: 3000 });
          }
        })
        .catch(() => {
          toast.error("An error occurred. Please try again.", { position: "top-right", autoClose: 3000 });
        })
        .finally(() => {
          setIsSubmitting(false); // re-enable after request finishes
        });
    };


/*
    // 1. Listen for Android Success
    useEffect(() => {
      const savedId = localStorage.getItem("oneSignalId");
      if (savedId) setOneSignalId(savedId);

      // Define the global callback for Android
      window.onGoogleAuthSuccess = (idToken) => {
          processGoogleLogin(idToken);
      };

      window.onGoogleAuthFailure = (error) => {
          toast.error("Google Sign-in failed: " + error);
      };
  }, []);

  // 2. Function to send token to your Node.js server
  const processGoogleLogin = (token) => {
      setIsSubmitting(true);
      axios.post(`${API_URL}/api/auth/google`, {
          token: token,
          oneSignalId: localStorage.getItem("oneSignalId")
      })
      .then(res => {
          if (res.data.Status === "Success") {
              localStorage.setItem('user_id', res.data.user_id);
              localStorage.setItem('family_code', res.data.family_code);
              localStorage.setItem('family_admin', res.data.family_admin);
              toast.success("Login successful!");
              navigate(res.data.redirect);
          } else {
              toast.error(res.data.Message);
          }
      })
      .catch(() => toast.error("Server connection failed"))
      .finally(() => setIsSubmitting(false));
  };

  // 3. Button Click Handler
  const handleGoogleBtnClick = () => {
      if (window.Android && window.Android.triggerGoogleAuth) {
          window.Android.triggerGoogleAuth();
      } else {
          toast.info("Google Sign-in is currently available on the mobile app.");
      }
  };
*/
     
    const baseUnderline = '2px solid #2e8f66';
    const focusUnderline = '2px solid #184a2c';
  
    // Same assets approach as Register
    const bgUrl = `${process.env.PUBLIC_URL}/img/login.jpg`;
    const logoUrl = `${process.env.PUBLIC_URL}/img/logo_1.png`;

      
    return (
        <div
              className="d-flex align-items-center justify-content-center vh-100"
              style={{
                backgroundImage: `url(${bgUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative'
              }}
            >
              {/* Overlay (same tone as Register) */}
              <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ backgroundColor: 'rgba(0,0,0,0.25)' }}
              />
              <ToastContainer />
        
              {/* Card (same look as Register: solid white box, rounded) */}
              <div
          className="shadow border-0"
          style={{
            width: 480,
            maxWidth: '95%',
            overflow: 'hidden',
            zIndex: 1,
            backgroundColor: 'rgba(255, 255, 255, 0.33)', // Semi-transparent white
            backdropFilter: 'blur(03px)', // Optional: adds a nice frosted glass effect
            borderRadius: 10 // optional if you want smooth edges
          }}
        >

        
                {/* Header (same gradient as Register) */}
                <div
                  className="text-white"
                  style={{
                    background: 'linear-gradient(135deg, #065c0cff, #088e3eff)',
                    padding: '20px',
                    textAlign: 'center'
                  }}
                >
                  <img src={logoUrl} alt="Logo" height="50" className="mb-2" /> 
 
      

                  <h4 className="fw-bold mb-1">Sign in</h4>
                  <small style={{ opacity: 0.9 }}>Welcome back</small>
                </div>
        
                {/* Body */}
                <div className="px-4 pb-4" style={{ marginTop: 10 }}>
                  <form onSubmit={handleSubmit} className="pt-2">
                    {/* Email (no placeholder, label only) */}
                    <div className="mb-3">
                      <label className="form-label mb-1 fw-semibold" style={{ color: '#0ca031ff' }}>
                        Email or phone
                      </label>
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control border-0"
                          aria-label="Email or phone"
                           
                          style={{
                            backgroundColor: '#f7fdf9',
                            borderBottom: baseUnderline,
                         
                            paddingLeft: 12,
                            paddingRight: 36
                          }}
                          value={values.email_phone}
                          onChange={(e) => setValues({ ...values, email_phone: e.target.value })}

                          onFocus={(e) => (e.target.style.borderBottom = focusUnderline)}
                          onBlur={(e) => (e.target.style.borderBottom = baseUnderline)}
                          required
                        />
                        {values.email_phone && (
                              <i
                                className={`bi ${
                                  isValidEmail(values.email_phone) || isValidPhone(values.email_phone)
                                    ? 'bi-check2'
                                    : 'bi-x-lg'
                                }`}
                                style={{
                                  position: 'absolute',
                                  right: 10,
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  fontSize: 18,
                                  color:
                                    isValidEmail(values.email_phone) || isValidPhone(values.email_phone)
                                      ? '#2e8f66'
                                      : '#c0392b'
                                }}
                              />
                            )}
                      </div>
                    </div>
        
                    {/* Password (no placeholder, label only) */}
                    <div className="mb-2">
                      <label className="form-label mb-1 fw-semibold" style={{ color: '#0bcb35ff' }}>
                        Password
                      </label>
                      <div className="position-relative">
                        <input
                          type={showPw ? 'text' : 'password'}
                          className="form-control border-0"
                          aria-label="Password"
                         
                          style={{
                            backgroundColor: '#f7fdf9',
                            borderBottom: baseUnderline,
                            borderRadius: 10,
                            paddingLeft: 12,
                            paddingRight: 40
                          }}
                          value={values.password}
                          onChange={(e) => setValues({ ...values, password: e.target.value })}
                          onFocus={(e) => (e.target.style.borderBottom = focusUnderline)}
                          onBlur={(e) => (e.target.style.borderBottom = baseUnderline)}
                          required
                        />
                        <button
                          type="button"
                          onClick={() => setShowPw((prev) => !prev)}
                          className="btn btn-link p-0"
                          style={{
                            position: 'absolute',
                            right: 8,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            textDecoration: 'none',
                            color: '#666'
                          }}
                          aria-label={showPw ? 'Hide password' : 'Show password'}
                        >
                          <i className={`bi ${showPw ? 'bi-eye-slash' : 'bi-eye'}`} style={{ fontSize: 18 }} />
                        </button>
                      </div>
                    </div>
        
                    {/* Forgot password */}
                    <div className="d-flex justify-content-end mb-4">
                      <Link to="/forgot-password" className="text-decoration-none" style={{ color: '#229007ff' }}>
                        Forgot password?
                      </Link>
                    </div>
        
                    {/*(same style as Register) */}
                    <button
                      type="submit"
                      className="btn w-100 text-white fw-bold"
                      style={{
                        background: 'linear-gradient(90deg, #2e8f66, #184a2c)',
                        borderRadius: 10,
                        padding: 14,
                        fontSize: 16
                      }}
                      disabled={isSubmitting}
                      >

                    {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" style={{ width: '0.8rem', height: '0.8rem' }}></span>
                          SIGNING IN...
                        </>
                      ) : (
                        <>
                           
                          SIGN IN
                        </>
                      )}
                      
                    </button>
                  </form>

                  {/*<button
                        type="button"
                        onClick={handleGoogleBtnClick}
                        className="btn w-100 mt-2 d-flex align-items-center justify-content-center"
                        style={{
                            backgroundColor: '#fff',
                            color: '#757575',
                            border: '1px solid #dadce0',
                            borderRadius: 10,
                            padding: 12,
                            fontWeight: '500'
                        }}
                        disabled={isSubmitting}
                    >
                        <img 
                            src="https://fonts.gstatic.com/s/i/productlogos/googleg/v6/24px.svg" 
                            alt="Google" 
                            className="me-2" 
                        />
                        {isSubmitting ? "Processing..." : "Sign in with Google"}
                    </button>*/}
        
                  {/* Sign up link (same style as Register) */}
                  <div className="text-center mt-3">
                    Don’t have an account?{' '}
                    <Link to="/register" className="fw-bold" style={{ color: '#184a2c' }}>
                      Sign up
                    </Link>
                  </div>
                </div>
              </div>
            </div>
    );
}

export default Login;
